<dx-data-grid #masterDetailsGridContainer class="data-grid" [dataSource]="lineItems" [remoteOperations]="false" [allowColumnReordering]="true" [rowAlternationEnabled]="true" [showBorders]="true">
	<dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
	<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
	<dxo-group-panel [visible]="false"></dxo-group-panel>
	<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="false"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column dataField="type" dataType="text" alignment="left" caption="Type"></dxi-column>
	<dxi-column dataField="partNumber" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="quantity" dataType="number" alignment="right" caption="Quantity"></dxi-column>
	<dxi-column dataField="dateRequired" dataType="date" caption="Date Required" format="dd/MM/yyyy"></dxi-column>
</dx-data-grid>